var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArchive2 = function SvgArchive2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    viewBox: "0 0 13 11.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 2.167C0 .97.97 0 2.167 0h8.666a2.167 2.167 0 0 1 .834 4.167v5a2.5 2.5 0 0 1-2.5 2.5H3.833a2.5 2.5 0 0 1-2.5-2.5v-5a2.17 2.17 0 0 1-1.333-2m2.333 2.166v4.834a1.5 1.5 0 0 0 1.5 1.5h5.334a1.5 1.5 0 0 0 1.5-1.5V4.333zM2.167 1a1.167 1.167 0 1 0 0 2.333h8.666a1.167 1.167 0 1 0 0-2.333z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.436 7.533H4.564"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArchive2);
export default ForwardRef;